<template>
  <div class="release-modal-wrapper">
    <modal
      name="productDetail"
      :adaptive="true"
      height="auto"
      width="1000px"
      class="u-text-align-center"
      @closed="hide">
      <div class="product-modal">
        <div class="modal-disc__title-block">
          <div
            v-if="item.type==='single'"
            class="modal-disc__title">
            {{ item.title || item.title_en }}
            {{ `${featuringJa(item.discs[0].tracks[0])}${versionJa(item)}` }}
          </div>
          <div
            v-else
            class="modal-disc__title">
            {{ item.title || item.title_en }} {{ versionJa(item) }}
          </div>
          <div class="modal-disc__artist">
            {{ item.artist_name }}
          </div>
        </div>
        <div class="modal-disc-detail">
          <div class="modal-disc__artwork">
            <img
              :src="`/images/${item.coverart_filepath}`"
              alt="">
          </div>
          <div>
            <div
              v-for="(disc,discIndex) in item.discs"
              :key="disc.id"
              class="modal-disc__songs">
              <div v-if="item.discs.length > 1">DISC.{{ discIndex+1 }}</div>
              <div
                v-for="(track, index) in disc.tracks"
                :key="track.id">
                {{ index + 1 }}.
                {{ `${track.titles[0].title}${featuringJa(track)}${versionJa(track)}` }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-disc__subscription-block">
          <div class="modal-disc__subscription-text">
            Available on
          </div>
          <div class="modal-disc__subscription-list">
            <a
              v-for="(provider, index) in availableProviders"
              :key="index"
              class="modal-disc__subscription-list-item">
              <img
                :src="`/img/common/providers/${provider}.jpg?v=1`"
                :alt="provider"
                :title="provider">
            </a>
          </div>
        </div>
        <p class="modal-disc-info">
          {{ item.remarks_ja }}
        </p>
        <div class="c-btn-wrap">
          <a
            href="#"
            class="c-btn c-btn--close c-btn--narrow js-modal-close"
            @click.prevent="hide">
            閉じる
            <span class="c-btn__icon-close">
              <span></span>
            </span>
          </a>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>

export default {
  name: 'ReleaseModal',
  filters: {
    toJapanese: (value) => (value === 'single' ? 'シングル' : 'アルバム'),
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    isShown: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      item: {},
      featuringPrefixes: {},
    }
  },
  computed: {
    availableProviders() {
      if (!this.item.restrictions) {
        return []
      }

      const duplicatedStore = {
        'uma-dl': 'uma',
        '7digital-dl': '7digital',
      }

      const restrictions = this.item.restrictions.filter(
        item => (!item.provider.disabled && item.provider.key !== 'recochoku' && item.provider.key !== 'recochoku-dl'),
      ).map(item => (duplicatedStore[item.provider.key]
        ? duplicatedStore[item.provider.key] : item.provider.key))

      // dヒッツ、Rec Music、dミュージック月額コース、ひかりTVミュージック
      if (this.item.restrictions.filter(item => item.provider.key === 'recochoku').length) {
        restrictions.push('dhits-otoraku')
        restrictions.push('recmusic')
        restrictions.push('dmusic')
        restrictions.push('hikaritv')
      }

      // レコチョク、dミュージック powered by レコチョク、ひかりTVミュージック、Music Store powered by レコチョク
      if (this.item.restrictions.filter(item => item.provider.key === 'recochoku-dl').length) {
        restrictions.push('recochoku-dl')
        restrictions.push('dmusic-dl')
        restrictions.push('hikaritv')
        restrictions.push('musicstore-dl')
      }

      return [...new Set(restrictions)]
    },
  },
  watch: {
    isShown() {
      if (this.isShown) {
        this.show()
      } else {
        this.hide()
      }
    },
    id() {
      this.fetchItem(this.id)
    },
  },
  mounted() {
    this.fetchFeaturingPrefixes()
  },
  methods: {
    async fetchItem(id) {
      this.loading = true
      const { data } = await window.axios.get(`/api/client/products/${id}`)
      this.item = data
      this.loading = false
    },
    show() {
      this.$modal.show('productDetail')
      this.fetchItem(this.id)
    },
    hide() {
      this.$modal.hide('productDetail')
      this.$emit('closed')
    },
    // Featuringの接続表記マスタを取得
    async fetchFeaturingPrefixes() {
      const { data } = await window.axios.get('/api/client/code/featuring-prefixes')
      this.featuringPrefixes = data
    },
    featuringJa(track) {
      if (!track.meta_artists.featuring_artists
          || track.meta_artists.featuring_artists.length === 0) {
        return ''
      }
      const prefexIndex =  track.meta_artists.featuring_artists[0].prefix ?? 0
      const jaFeaturings = track.meta_artists.featuring_artists.map(featuring => featuring.name_ja)
      return (` ${this.featuringPrefixes[prefexIndex]} ` ?? ' ') + jaFeaturings.join(',')
    },
    versionJa(track) {
      if (!track.versions || track.versions.length === 0) {
        return ''
      }
      const jaVersions = track.versions.filter(version => version.language === 'ja')
      return jaVersions.length > 0
        ? ` (${jaVersions[0].version})`
        : ` (${track.versions[0].version})`
    },
  },
}
</script>

<style scoped>
.product-modal {
  padding: 2vmin;
}
@media screen and (min-width: 896px) {
  .product-modal {
    max-height: 80vh!important;
    overflow: scroll;
  }
}
@media screen and (max-width: 895px) {
  .product-modal {
    height: 90vh!important;
    overflow: scroll;
  }
}
</style>
